import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import ErrorLayout from '../layouts/ErrorLayout';
import Error404 from 'components/errors/Error404';
import CardLogin from 'components/authentication/card/Login';
import Logout from 'components/authentication/card/Logout';
import Dashboard from 'components/dashboards/default';
import SupportDesk from 'components/dashboards/support-desk';
import TableView from 'components/app/support-desk/tickets-layout/TableView';
import ContactDetails from 'components/app/support-desk/contact-details/ContactDetails';
import FormAlumno from 'components/app/alumnos/FormAlumno';
import Home from 'components/dashboards/default/Home';
import FormCurso from 'components/app/cursos/FormCurso';
import FormProfesor from 'components/app/profesores/FormProfesor';
import TableViewCurso from 'components/app/support-desk/tickets-layout/TableViewCurso';
import TableViewProfesores from 'components/app/support-desk/tickets-layout/TableViewProfesores';
import FormUser from 'components/app/users/FormUser';
import TableViewUsers from 'components/app/support-desk/tickets-layout/TableViewUsers';
import TableViewExamenes from 'components/app/support-desk/tickets-layout/TableViewExamenes';
import TableViewAlumnosNextCicle from 'components/app/support-desk/tickets-layout/TableViewAlumnosNextCicle';
import TableViewCuotas2025 from 'components/app/support-desk/tickets-layout/TableViewCuotas2025';
import FormCuota from 'components/app/cuotas/FormCuotas';
import TableCuotasMonth from 'components/app/support-desk/tickets-layout/TableCuotasMonth';
import TableCuotasAllMonth from 'components/app/support-desk/tickets-layout/TableCuotasAllMonth';
import Pagos from 'components/dashboards/default/Pagos';
import Reportes from 'components/dashboards/default/Reportes';
import TableCuotasByMonth from 'components/app/support-desk/tickets-layout/TableCuotasByMonth';
import Faq from 'components/documentation/Faq';

const FalconRoutes = () => {
  return (
    <Routes>
      <Route element={<ErrorLayout />}>
        <Route path="errors/404" element={<Error404 />} />
      </Route>
      {/*- ------------- Authentication ---------------------------  */}
      {/*- ------------- Card ---------------------------  */}
      <Route path="login" element={<CardLogin />} />
      <Route path="authentication/card/logout" element={<Logout />} />
 
      {/* //--- MainLayout Starts  */}
      <Route element={<MainLayout />}>
        {/*Dashboard*/}
        <Route path="/" element={<Home />} />
        <Route path="dashboard/support-desk" element={<SupportDesk />} />
        {/*Alumnos*/}
        <Route path="/alumnos/lista/:id" element={<TableView />} />
        <Route path='/alumnos/nuevo/:id?' element={<FormAlumno />} />
        <Route path='/alumnos/lista-a/:id' element={<TableViewExamenes />} />
        <Route path="/alumnos/lista-2025" element={<TableViewAlumnosNextCicle />} />
        <Route
          path="/support-desk/contact-details/:id/:ciclo?"
          element={<ContactDetails />}
        />
        <Route path="/estados-cuentas/:id" element={<Pagos />} />
        {/*Cursos*/}
        <Route path="/cursos/nuevo" element={<FormCurso />}/>
        <Route path="/cursos/lista" element={<TableViewCurso />} />
        {/*Profesores*/}
        <Route path="/profesores/lista" element={<TableViewProfesores />} />
        <Route path="/profesores/nuevo" element={<FormProfesor />} />
        {/*Users*/}
        <Route path="/users/nuevo" element={<FormUser />} />
        <Route path="/users/lista" element={<TableViewUsers />} />
        {/* Pagos */}

        <Route path="/pagos" element={<Dashboard />} />
        <Route path="/reportes" element={<Reportes />} />
        <Route path="/alumnos/cuotas" element={<TableViewCuotas2025 />} />
        <Route path="/alumnos/cuotas/nuevo/:id" element={<FormCuota />} />
        <Route path="/alumnos/cuotas/meses" element={<TableCuotasMonth />} />
        <Route path="/alumnos/cuotas/meses-all" element={<TableCuotasAllMonth />} />
        <Route path="/alumnos/cuotas/abril" element={<TableCuotasByMonth month={'abril'} />} />
        <Route path="/alumnos/cuotas/marzo" element={<TableCuotasByMonth month={'marzo'} />} />
        <Route path="/alumnos/cuotas/mayo" element={<TableCuotasByMonth month={'mayo'} />} />
        <Route path="/alumnos/cuotas/junio" element={<TableCuotasByMonth month={'junio'} />} />
        <Route path="/alumnos/cuotas/julio" element={<TableCuotasByMonth month={'julio'} />} />
                <Route path="documentation/faq" element={<Faq />} />
      </Route>
      {/* //--- MainLayout end  */}
    </Routes>
  );
};

export default FalconRoutes;
